import { Box, Header, Text, addWithConfig } from '@rbilabs/universal-components';

import ActionButtonLink from 'components/action-button';
import { theme } from 'styles/configure-theme';

export const EmptyStateWrapper = Box.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  color: theme.token('text-default'),
  marginTop: '$10',
});

export const StyledActionButtonLink = addWithConfig(ActionButtonLink).withConfig({
  style: { marginTop: 16 },
});

export const HeaderText = Header.withConfig({
  variant: 'headerOne',
  margin: 0,
  fontSize: 'xl',
  lineHeight: 'md',
  marginTop: '$4',
});

export const SubText = Text.withConfig({
  variant: 'copyOne',
  marginTop: '$4',
  marginX: '$8',
  marginBottom: '$0',
  fontSize: 'md',
  textAlign: 'center',
});

export const ImageWrapper = Box.withConfig({
  height: '87px',
  width: 'full',
  alignItems: 'center',
  marginTop: '$2',
});
